import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCartContext } from '../customHooks/useCart';
import { translate } from '../utils/translator';

type Props = { riskGroup: RiskGroupSummary };

const RiskGroupProductWarning: React.FC<Props> = ({ riskGroup }) => {
  const { language } = useParams();
  const { setRiskGroupConfirmation } = useCartContext();
  const [loading, setLoading] = useState(false);
  const hardLimitExceeded = riskGroup.status === 'hard_limit_exceeded';
  const title = translate(language, 'shipping', hardLimitExceeded ? 'riskGroups/hard_limit' : 'riskGroups/soft_limit_title')
    .replace('{group_name}', riskGroup.name);
  const description = translate(language, 'shipping', 'riskGroups/soft_limit_description')
    .replace('{threshold}', String(riskGroup.soft_threshold));
  const checkboxLabel = translate(language, 'shipping', 'riskGroups/confirmation');

  const updateConfirmation = async (confirmed: boolean) => {
    if (loading) return;
    setLoading(true);
    try {
      const result = await setRiskGroupConfirmation(riskGroup.id, confirmed);
      if (result.status !== 'ok') setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[8px] flex flex-col gap-[10px] rounded-[14px] bg-[#ffeaea] px-[14px] py-[14px] text-[13px] leading-[18px]">
      <div className="flex items-center gap-[8px]">
        <svg className="h-[16px] w-[16px] shrink-0 text-[#c73535]" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.25" />
          <path d="M8 7v4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
          <circle cx="8" cy="4.75" r=".75" fill="currentColor" />
        </svg>
        <p className="font-medium text-[#c73535]">{title}</p>
      </div>
      {!hardLimitExceeded && (
        <>
          <p className="font-semibold text-[#0D2C54]">{description}</p>
          <label className={`flex items-center gap-[10px] text-[#2E3E67] ${loading ? 'cursor-wait opacity-70' : 'cursor-pointer'}`}>
            <input type="checkbox" className="h-[18px] w-[18px] shrink-0 cursor-pointer accent-[#707885]" checked={riskGroup.confirmed} disabled={loading} onChange={(event) => updateConfirmation(event.target.checked)} />
            <span>{checkboxLabel}</span>
          </label>
        </>
      )}
    </div>
  );
};

export default RiskGroupProductWarning;
